import React, { useCallback, useEffect, useState } from "react";
import { Users, Plus } from "lucide-react";
import { toast } from "sonner";
import { wapi } from "@/lib/api";

export const TeamAdmin = () => {
  const [team, setTeam] = useState([]);
  const [email, setEmail] = useState("");
  const [confirm, setConfirm] = useState("");
  const [pwFor, setPwFor] = useState("");
  const [pwVal, setPwVal] = useState("");

  const load = useCallback(() => {
    wapi.get("/workers/team").then((r) => setTeam(r.data.team)).catch(() => toast.error("Não foi possível carregar a equipe."));
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!email.trim() || !email.includes("@")) return toast.error("Digite um e-mail válido.");
    try {
      await wapi.post("/workers/team", { email: email.trim() });
      toast.success("E-mail autorizado. A pessoa já pode entrar com o Google dela — ou defina uma senha abaixo.");
      setEmail("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível adicionar.");
    }
  };

  const remove = async (em) => {
    try {
      await wapi.delete(`/workers/team/${encodeURIComponent(em)}`);
      toast.success("Acesso removido.");
      setConfirm("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível remover.");
    }
  };

  const setPassword = async (em) => {
    try {
      const r = await wapi.post(`/workers/team/${encodeURIComponent(em)}/password`, { password: pwVal });
      toast.success(r.data.has_password ? "Senha definida. Passe para a pessoa por um canal seguro." : "Acesso por senha removido.");
      setPwFor("");
      setPwVal("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível definir a senha.");
    }
  };

  return (
    <section className="border-t border-border pt-10" data-testid="team-admin">
      <p className="font-sans uppercase tracking-[0.22em] text-[11px] font-semibold text-primary flex items-center gap-2">
        <Users size={14} strokeWidth={1.5} /> Equipe
      </p>
      <h2 className="mt-2 font-serif text-2xl">E-mails autorizados a entrar nesta área.</h2>

      <div className="mt-5 flex gap-2 flex-wrap">
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          placeholder="email@exemplo.com"
          className="flex-1 min-w-[240px] min-h-[48px] px-4 bg-secondary/40 rounded-md border border-border text-base outline-none focus:border-primary transition-colors"
          data-testid="team-email-input"
        />
        <button onClick={add} className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 font-sans text-sm font-semibold text-primary-foreground hover:bg-primary/90 transition-colors min-h-[48px]" data-testid="team-add">
          <Plus size={16} /> Autorizar e-mail
        </button>
      </div>

      <ul className="mt-6 divide-y divide-border/60">
        {team.map((m) => (
          <li key={m.email} className="py-3.5 flex items-center justify-between gap-3 flex-wrap" data-testid={`team-member-${m.email}`}>
            <div>
              <p className="font-sans text-base">{m.name || m.email}</p>
              <p className="font-sans text-sm text-muted-foreground">
                {m.email}{m.is_admin ? " · administrador" : ""}{!m.active ? " · acesso removido" : ""}{m.has_password ? " · com senha" : ""}
              </p>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {m.active && (
                pwFor === m.email ? (
                  <span className="inline-flex items-center gap-2 flex-wrap" data-testid="team-pw-form">
                    <input
                      type="text" value={pwVal} onChange={(e) => setPwVal(e.target.value)}
                      placeholder="Nova senha (mín. 6) — vazio remove"
                      className="min-h-[40px] px-3 bg-secondary/40 rounded-md border border-border text-sm outline-none min-w-[220px]"
                      data-testid="team-pw-input"
                    />
                    <button onClick={() => setPassword(m.email)} className="rounded-full bg-primary px-4 py-2 font-sans text-sm font-semibold text-primary-foreground" data-testid="team-pw-save">Salvar</button>
                    <button onClick={() => { setPwFor(""); setPwVal(""); }} className="rounded-full border border-border px-4 py-2 font-sans text-sm">Voltar</button>
                  </span>
                ) : (
                  <button onClick={() => { setPwFor(m.email); setPwVal(""); }} className="rounded-full border border-border px-4 py-2 font-sans text-sm text-muted-foreground hover:text-primary hover:border-primary transition-colors" data-testid={`team-pw-${m.email}`}>
                    {m.has_password ? "Trocar senha" : "Definir senha"}
                  </button>
                )
              )}
              {m.active && !m.is_admin && (
                confirm === m.email ? (
                  <span className="inline-flex items-center gap-2">
                    <span className="font-sans text-sm text-muted-foreground">Remover acesso?</span>
                    <button onClick={() => remove(m.email)} className="rounded-full bg-red-600 px-4 py-2 font-sans text-sm font-semibold text-white" data-testid="team-remove-yes">Sim</button>
                    <button onClick={() => setConfirm("")} className="rounded-full border border-border px-4 py-2 font-sans text-sm">Não</button>
                  </span>
                ) : (
                  <button onClick={() => setConfirm(m.email)} className="rounded-full border border-border px-4 py-2 font-sans text-sm text-muted-foreground hover:text-red-600 hover:border-red-300 transition-colors" data-testid="team-remove">
                    Remover
                  </button>
                )
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
